export const ARCHIVED_ERROR = {
  display: true,
  variant: 'danger',
  title: 'Warning alert: ',
  message:
    'Unable to show archived version due to technical problems, please contact the system administrator.',
};

export const ROLLBACK_ERROR = {
  display: true,
  variant: 'danger',
  title: 'Warning alert: ',
  message:
    'Unable to publish new version due to technical problems, please contact the system administrator.',
};

export const CONFIRMATION_MODAL_DEFAULT_MESSAGE = 'Confirmation';
export const CONFIRMATION_MODAL_CANCEL_BUTTON = 'Cancel';
export const CONFIRMATION_MODAL_WAITING_RESPONSE = 'Waiting response...';
export const METADATA_BOX_TITLE = 'Information';
export const VERSION_BOX_TITLE = 'Version History';
export const VERSION_BOX_CURRENT_VERSION_LABEL = 'Current version';
export const RELATIONS_BOX_TITLE = 'Relations';

export const PUBLISHED_SUCCESSFULLY_MESSAGE = {
  display: true,
  variant: 'success',
  title: 'Published successfully',
  message: '',
};

export const PUBLISHED_SUCCESSFULLY_VERSION = {
  variant: 'success',
  message: 'a new version was generated',
  title: 'Course published succesfully: ',
};

export const SAVING_DRAFT_ERROR = {
  variant: 'danger',
  message: 'Something went wrong saving the draft',
};
export const SAVING_DRAFT_SUCCESS = {
  variant: 'success',
  message: 'Draft saved successfully',
};

export const SUCCESS_STATUS = {
  variant: 'success',
  message: 'Viewing published version',
};
export const WARNING_STATUS = {
  variant: 'warning',
  message: 'Viewing released version',
};

export const OLD_VERSION_CONFIRMATION = {
  title: 'Publish old version?',
  text: 'Publishing this old version will generate another version and impact on future enrollments. Do you want to proceed?',
  btnLabel: 'Publish',
};

export const SAVE_DRAFT_CONFIRMATION = {
  title: 'Save draft?',
  text: 'Saving this change will overwrite the current draft. Do you want to proceed?',
  btnLabel: 'Save draft',
};

export const PUBLISH_COURSE_CONFIRMATION = {
  title: 'Publish new version?',
  text: [
    'Publishing this change will generate another',
    'version and impact on future enrollments.',
    'Do you want to proceed?',
  ],
  btnLabel: 'Publish',
};

export const ROLLBACK_COURSE_CONFIRMATION = {
  title: 'Publish older version?',
  text: [
    'Publishing this older version will generate',
    'another version and impact on future enrollments.',
    'Do you want to proceed?',
  ],
  btnLabel: 'Publish',
};

export const PREVENT_LOSS_CHANGES = {
  title: 'Confirmation',
  text: 'Are you sure you want to leave this page? All your modifications will be lost',
  confirmationButton: 'Confirm',
};

export const UNSAVED_CHANGES_NAVIGATION_WARNING = {
  title: 'Unsaved Changes',
  text: 'You have unsaved changes. Please save your course before proceeding, or your changes will be lost.',
  confirmationButton: 'Continue anyway',
};

export const LEARNOSITY_ACTIONS = {
  PREVIEW: 'preview',
  EDIT: 'edit',
  ASSIGN: 'assign',
  CREATE: 'create',
  ENDING: 'items.',
  EXPORT: 'export',
  SEPARATOR: ' and ',
};

export const ENTITY_ACTIONS = {
  ASSIGN: 'Assign',
  CANCEL: 'Cancel',
  CREATE: 'Create',
  CREATE_NEW: 'Create new',
  EDIT: 'Edit',
  PREVIEW: 'Preview',
  SAVE: 'Save',
};

export const LOGIN_MESSAGES = {
  LOGIN: {
    TITLE: 'Welcome back!',
    SUBTITLE: 'Log in to your FourPeaks account',
  },
  REGISTER: {
    TITLE: 'Welcome!',
    SUBTITLE:
      'Your credentials are only used to authenticate yourself on the admin panel. All saved data will be stored in your own database.',
  },
};

export const ASSESSMENT_FIELDS = {
  TITLE: {
    label: 'Title',
    placeholder: 'Enter a Title',
  },

  UID: {
    label: 'UUID',
    placeholder: 'Enter a UUID',
    name: 'uid',
  },

  TYPE: {
    label: 'Type',
    placeholder: 'Select Type',
  },

  QUANTITY: {
    label: 'Quantity',
  },

  QUESTION_POOL: {
    label: 'Question Pool',
    placeholder: 'Select Question Pool',
    name: 'question_pool',
    values: {
      DYNAMIC: 'Dynamic',
      FIXED: 'Fixed',
      STUDY_TOPICS: 'StudyTopics',
    },
  },

  TIME_PER_QUESTION: {
    label: 'TimePerQuestion',
    name: 'timePerQuestion',
  },

  INSTRUCTIONS: {
    label: 'Instructions',
    name: 'instructions',
  },

  FEEDBACK_TOGGLE: {
    label: 'View Assessment Feedback',
    name: 'view_assessment_feedback',
    onLabel: 'TRUE',
    offLabel: 'FALSE',
    required: true,
  },

  CHECK_ANSWER_TOGGLE: {
    label: 'Check Answer',
    name: 'check_answer',
    onLabel: 'TRUE',
    offLabel: 'FALSE',
    required: true,
  },

  MAX_ATTEMPTS: {
    label: 'Max Attempts',
    placeholder: 'Enter max attempts',
    name: 'max_attempts',
    required: false,
  },

  START_DATE: {
    label: 'Start Date',
    name: 'start_date',
    required: false,
  },

  END_DATE: {
    label: 'End Date',
    placeholder: '0',
    name: 'end_date',
    required: false,
  },
};

export const NUMBER_TYPE = 'number';
export const DECIMAL_TYPE = 'decimal';

export const MAX_LENGTH_ERROR = (maxLength) =>
  `Value cannot exceed ${maxLength} characters`;

export const ROLLBACK_METADATA_LAST_ROLLBACK_MESSAGE = 'Last Rollback';
export const ROLLBACK_METADATA_BY_MESSAGE = 'By';
export const ROLLBACK_METADATA_RESTORED_FROM = 'Restored from';
export const ROLLBACK_METADATA_TOOLTIP_CONTENT =
  'Last time a previous version was restored';

export const API_COLLECTION_NAMES = {
  container: 'api::container.container',
  activity: 'api::activity.activity',
  assessment: 'api::assessment.assessment',
  examTopic: 'api::exam-topic.exam-topic',
};

export const IMPACT_LEVES = {
  impact_level_4: 'critical',
  impact_level_3: 'serious',
  impact_level_2: 'moderate',
  impact_level_1: 'minor',
};

export const IMPACT_LEVEL_4 = 'impact_level_4';
export const IMPACT_LEVEL_3 = 'impact_level_3';
export const IMPACT_LEVEL_2 = 'impact_level_2';
export const IMPACT_LEVEL_1 = 'impact_level_1';

export const NOTIFICATION_WARNING = {
  type: 'warning',
  message: 'Something went wrong',
};

export const NOTIFICATION_SUCCESS = {
  type: 'success',
  message: 'Success!',
};
